import { createApi } from "@reduxjs/toolkit/query/react";
import { AddressSuggestion } from "../../types";
import { LOCATION } from "../../configs";
import { createBaseQuery } from "../helpers/baseQueryHelper";

const locationApi = createApi({
  reducerPath: LOCATION.reducerPath,
  baseQuery: createBaseQuery(LOCATION.baseUrl),
  tagTypes: LOCATION.tagTypes,
  endpoints(builder) {
    return {
      fetchAddressSuggestins: builder.query<AddressSuggestion[], string>({
        query: (searchInput: string) => {
          return {
            url: `/suggest?q=${searchInput}`,
            method: "GET",
          };
        },
      }),
    };
  },
});

export const { useFetchAddressSuggestinsQuery } = locationApi;

export { locationApi };
